export const FORM_LOGOUT_EMPLOYEE = ({ branchOption }) => {
  return [
    {
      name: 'employeeId',
      label: 'เลขประจําตัวประชาชน',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'branchId',
      label: 'สาขา',
      type: 'DROPDOWN',
      properties: {
        options: branchOption || [],
      },
    },
  ];
};
